import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[gcInputMask]',
  standalone: false,
})
export class InputMaskDirective {
  @Input('gcInputMask') mask: string;
  constructor(private readonly ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    const target = event.target as HTMLInputElement;
    if (this.ngControl) {
      this.ngControl.control.setValue(this.parseValue(target.value));
    }
  }

  private parseValue(value: string) {
    let newVal = '';
    for (let i = 0; i < value.length; i++) {
      const chr = value.charAt(i);
      if (chr.match(this.mask)) {
        newVal += chr;
      }
    }
    return newVal;
  }
}
